export default "__VITE_ASSET__fOwgOWdm__"